module.exports = __webpack_public_path__ + "static/media/IMG_1129.20f39940.jpg";